<template>
  <b-container class="checkout-page py-4">
    <h1 class="mb-4">Finalizar Compra</h1>
    
    <b-row>
      <b-col lg="8">
        <!-- Shipping Information -->
        <b-card title="Información de Envío" class="mb-4">
          <b-form>
            <b-row>
              <b-col md="6">
                <b-form-group label="Nombre" label-for="firstName">
                  <b-form-input
                    id="firstName"
                    v-model="shippingInfo.firstName"
                    required>
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Apellido" label-for="lastName">
                  <b-form-input
                    id="lastName"
                    v-model="shippingInfo.lastName"
                    required>
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            
            <b-form-group label="Email" label-for="email">
              <b-form-input
                id="email"
                v-model="shippingInfo.email"
                type="email"
                required>
              </b-form-input>
            </b-form-group>
            
            <b-form-group label="Teléfono" label-for="phone">
              <b-form-input
                id="phone"
                v-model="shippingInfo.phone"
                type="tel"
                required>
              </b-form-input>
            </b-form-group>
            
            <b-form-group label="Dirección" label-for="address">
              <b-form-input
                id="address"
                v-model="shippingInfo.address"
                required>
              </b-form-input>
            </b-form-group>
            
            <b-row>
              <b-col md="6">
                <b-form-group label="Ciudad" label-for="city">
                  <b-form-input
                    id="city"
                    v-model="shippingInfo.city"
                    required>
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Provincia" label-for="state">
                  <b-form-input
                    id="state"
                    v-model="shippingInfo.state"
                    required>
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Código Postal" label-for="zipCode">
                  <b-form-input
                    id="zipCode"
                    v-model="shippingInfo.zipCode"
                    required>
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            
            <b-form-group label="Notas del pedido (opcional)" label-for="notes">
              <b-form-textarea
                id="notes"
                v-model="shippingInfo.notes"
                rows="3"
                placeholder="Instrucciones especiales para la entrega...">
              </b-form-textarea>
            </b-form-group>
          </b-form>
        </b-card>
        
        <!-- Payment Method -->
        <b-card title="Método de Pago" class="mb-4">
          <b-form-radio-group v-model="paymentMethod" stacked>
            <b-form-radio value="mercadopago" v-if="showMercadoPago">
              <div class="d-flex align-items-center">
                <b-icon icon="credit-card" class="mr-2"></b-icon>
                <span>Mercado Pago</span>
              </div>
              <small class="text-muted ml-4">Paga con tarjetas de crédito o débito</small>
            </b-form-radio>
            
            <b-form-radio value="cash" class="mt-3">
              <div class="d-flex align-items-center">
                <b-icon icon="cash" class="mr-2"></b-icon>
                <span>Efectivo contra entrega</span>
              </div>
              <small class="text-muted ml-4">Paga cuando recibas tu pedido</small>
            </b-form-radio>
            
            <b-form-radio value="transfer" class="mt-3">
              <div class="d-flex align-items-center">
                <b-icon icon="bank" class="mr-2"></b-icon>
                <span>Transferencia bancaria</span>
              </div>
              <small class="text-muted ml-4">Te enviaremos los datos por email</small>
            </b-form-radio>
          </b-form-radio-group>
        </b-card>
      </b-col>
      
      <!-- Order Summary -->
      <b-col lg="4">
        <b-card title="Resumen del Pedido" class="sticky-top">
          <b-list-group flush>
            <b-list-group-item 
              v-for="item in cartItems" 
              :key="item.id"
              class="d-flex justify-content-between align-items-center">
              <div>
                <strong>{{ item.name }}</strong>
                <br>
                <small class="text-muted">Cantidad: {{ item.quantity }}</small>
              </div>
              <span>${{ formatPrice(item.price * item.quantity) }}</span>
            </b-list-group-item>
            
            <b-list-group-item class="d-flex justify-content-between">
              <span>Subtotal:</span>
              <span>${{ formatPrice(subtotal) }}</span>
            </b-list-group-item>
            
            <b-list-group-item class="d-flex justify-content-between">
              <span>Envío:</span>
              <span>{{ shippingCost > 0 ? `$${formatPrice(shippingCost)}` : 'Gratis' }}</span>
            </b-list-group-item>
            
            <b-list-group-item class="d-flex justify-content-between">
              <h5 class="mb-0">Total:</h5>
              <h5 class="mb-0 text-success">${{ formatPrice(total) }}</h5>
            </b-list-group-item>
          </b-list-group>
          
          <b-button 
            variant="success" 
            size="lg"
            block
            class="mt-3"
            @click="placeOrder"
            :disabled="loading || !isFormValid">
            <b-spinner v-if="loading" small class="mr-2"></b-spinner>
            Confirmar Pedido
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'CheckoutPage',
  data() {
    return {
      shippingInfo: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        notes: ''
      },
      paymentMethod: 'cash',
      shippingCost: 0,
      loading: false
    }
  },
  computed: {
    cartItems() {
      return this.$store.state.cart
    },
    subtotal() {
      return this.$store.getters.cartTotal
    },
    total() {
      return this.subtotal + this.shippingCost
    },
    showMercadoPago() {
      const config = this.$store.getters.shopConfig
      return config && config.show_mercadopago
    },
    isFormValid() {
      return this.shippingInfo.firstName &&
             this.shippingInfo.lastName &&
             this.shippingInfo.email &&
             this.shippingInfo.phone &&
             this.shippingInfo.address &&
             this.shippingInfo.city &&
             this.shippingInfo.state &&
             this.shippingInfo.zipCode &&
             this.paymentMethod
    }
  },
  created() {
    if (this.cartItems.length === 0) {
      this.$router.push({ name: 'Cart' })
    }
    
    // Si el usuario está autenticado, prellenar algunos campos
    const user = this.$store.state.user
    if (user) {
      this.shippingInfo.email = user.email || ''
      this.shippingInfo.phone = user.phone || ''
      const names = (user.name || '').split(' ')
      this.shippingInfo.firstName = names[0] || ''
      this.shippingInfo.lastName = names.slice(1).join(' ') || ''
    }
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('es-AR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(price)
    },
    async placeOrder() {
      if (!this.isFormValid) {
        this.$bvToast.toast('Por favor completa todos los campos requeridos', {
          title: 'Formulario incompleto',
          variant: 'warning',
          solid: true
        })
        return
      }
      
      this.loading = true
      
      const orderData = {
        shipping: this.shippingInfo,
        payment_method: this.paymentMethod,
        total: this.total
      }
      
      const result = await this.$store.dispatch('createOrder', orderData)
      
      if (result.success) {
        this.$bvToast.toast('Tu pedido ha sido confirmado', {
          title: 'Pedido exitoso',
          variant: 'success',
          solid: true
        })
        
        // Si es MercadoPago, redirigir al pago
        if (this.paymentMethod === 'mercadopago') {
          // Aquí iría la lógica de MercadoPago
          console.log('Procesando pago con MercadoPago...')
        }
        
        // Redirigir a página de confirmación o home
        this.$router.push({ name: 'Home' })
      } else {
        this.$bvToast.toast(result.message || 'Error al procesar el pedido', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
      
      this.loading = false
    }
  }
}
</script>

<style scoped>
.checkout-page {
  min-height: 60vh;
}

.sticky-top {
  top: 80px;
}
</style>